import React from 'react';
import { Dialog, Slide, withStyles } from 'material-ui';
import DialogStyles from './MealsSelectionDialogStyles';
// import SeatSelectionMobileContainer from './SeatSelectionMobileContainer';
import MealsSelectionDialogProps from './MealsSelectionDialogProps';
import MealsSelectionContainer from '../../common/mealsSelection/MealsSelectionContainer';

function Transition (props) {
  return <Slide direction='down' {...props} />;
}

const MealsSelectionDialog = ({
  editOpened,
  handleClose,
  classes,
  selectedPassenger,
  selectedRoute,
}) => (
  <div>
    <Dialog
      fullScreen
      open={editOpened}
      onClose={handleClose}
      transition={Transition}
      classes={classes}
    >
      <MealsSelectionContainer
        selectedRoute={selectedRoute}
        selectedPassenger={selectedPassenger}
        onConfirmationCallback={handleClose}
        handleClose={handleClose}
      />
    </Dialog>
  </div>
);

MealsSelectionDialog.propTypes = MealsSelectionDialogProps;

export default withStyles(DialogStyles)(MealsSelectionDialog);



// WEBPACK FOOTER //
// ./src/containers/meals/mobile/mealsSelection/MealsSelectionDialog.js